import { Box, Button } from '@mui/material';
import React from 'react';
import useDataPermission from '../../hooks/useDataPermission';
import { usePermissionStore } from '../../store/permission.store';
import { useNotify } from '../../provider/NotifyProvider';
import { useNavigate } from 'react-router-dom';
import URLS from '../../enums/route';
import { useAuth } from '../../store/auth.store';

const Edit = () => {
    const { user } = useAuth()
    const {deletePermission, updatePermission, create, data} = useDataPermission()
    const {choosedPermission, setChoosedPermission, text, setText, openEdit, setOpenEdit, color, setColor} = usePermissionStore()
    const {onSuccessNotify, onErrorNotify} = useNotify()
    const navigate = useNavigate()

    const deleteFunc = async () => {
        await deletePermission(choosedPermission?.id!)
        setChoosedPermission(null)
        setOpenEdit(false)
        setText('')
        setColor('#fff')
        navigate(URLS.BUSSNIES.LINK)
        setChoosedPermission(null)
     
    }

    const handleCorrectName = (): boolean => {
        const trimmed = text.trim();
        if (trimmed.length === 0) return false;
        const isDuplicate = data?.some(
            item => item.title === trimmed && item.id !== choosedPermission?.id
        );
        return !isDuplicate;
    };

    const submit = () => {
        if(choosedPermission?.id && choosedPermission?.id !== 99999999999){
            if(handleCorrectName()){
                updatePermission({...choosedPermission, title: text, color: color})
                setOpenEdit(false)
                setText('')
                setColor('#fff')
                onSuccessNotify('התגית עודכנה בהצלחה.')
                navigate(URLS.BUSSNIES.LINK)
                setChoosedPermission(null)
            } else {
                onErrorNotify("לא ניתן ליצור הרשה עם השם הזה")
            }
        } else {
            if(handleCorrectName()){
                setOpenEdit(false)
                create(user!,text,color,choosedPermission!) 
                setChoosedPermission(null)
            } else {
                onErrorNotify("לא ניתן ליצור הרשה עם השם הזה")
            }
        }
    }

    const cansle = () => {
        setChoosedPermission(null)
        setOpenEdit(false)
        setText('')
        setColor('#fff')
        navigate(URLS.BUSSNIES.LINK)
        setChoosedPermission(null)
    }

    return (
        <Box>
            {openEdit &&
                <>
                    <Box sx={{display:'flex', justifyContent:'center', gap:'10px'}}>
                        <Button variant='outlined' fullWidth sx={{bgcolor:'white'}} onClick={() => cansle()}>
                        ביטול
                        </Button>
                        <Button variant='contained' fullWidth onClick={() => submit()}>
                        אישור
                        </Button>
                    </Box>
                    {( choosedPermission && choosedPermission?.isEditable ) &&
                    <Button variant='outlined' fullWidth sx={{mt:'20px', bgcolor:'white', color:'#E92081', borderColor:'#E92081'}} onClick={() => deleteFunc()}>
                    מחק הרשאה
                    </Button>
                    }
                </>
            }
        </Box>
    );
};

export default Edit;